import { Fragment } from "react";

import { ConditionalWrapper } from "../ConditionalWrapper";
import { Column } from "../Layout";
import getField from "./getField";

const getColumns = (columns, uid) =>
    columns?.map((column) => (
        <Fragment key={uid(column)}>
            <ConditionalWrapper
                condition={column?.type !== "hidden"}
                Wrapper={Column}
                variant={column?.layout || "form.column"}
            >
                {getField(column)}
            </ConditionalWrapper>
        </Fragment>
    ));

export default getColumns;
